__turbopack_context__.v({
  "buttonPill": "japnaq_buttonPill",
  "content": "japnaq_content",
  "heroSearchBannerBackground": "japnaq_heroSearchBannerBackground",
});
